import * as React from 'react';
import { CssBaseline } from '@material-ui/core';
// import { Container } from 'reactstrap';

import { Container } from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import VitalsMDTheme from './VitalsMDTheme';
//import NavMenu from './NavMenu';
import BottomNav from './BottomNav';
import Drawer from './Drawer';
import AppBar from './AppBar';
import Hidden from '@material-ui/core/Hidden';
import { useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import './style.css';

export default class Layout extends React.PureComponent<{}, { children?: React.ReactNode }> {
    public render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <ThemeProvider theme={VitalsMDTheme}>
                    <Hidden mdUp>
                        <AppBar />
                    </Hidden>
                    <Hidden smDown>
                        <Drawer>
                            {this.props.children}
                        </Drawer>
                    </Hidden>

                    <Hidden mdUp>
                        <Container className="main-container">
                            {this.props.children}
                        </Container>
                        <BottomNav />
                    </Hidden>
                </ThemeProvider>
            </React.Fragment>
        );
    }
}

//const Layout: React.FC<{}, { children?: React.ReactNode }> = ({ children }) => {
//    const oidc = useSelector((state: any) => state.oidc);
//    const userLoggedIn = oidc == null ? false : oidc.user;

//    return (
//        <React.Fragment>
//            <CssBaseline />
//            <ThemeProvider theme={VitalsMDTheme}>
//                {userLoggedIn
//                    &&
//                    <NavMenu />
//                }
//                <Container>
//                    {children}
//                </Container>
//                {userLoggedIn
//                    &&
//                    <BottomNav />
//                }
//            </ThemeProvider>
//        </React.Fragment>
//    );
//}

//export default Layout;